import { Product } from './product';
import { Timestamp } from 'firebase/firestore';

export interface ProductVersion {
  id: string;
  productId: string;
  versionNumber: number;
  timestamp: Date | Timestamp;
  type: 'import' | 'optimization' | 'manual';
  marketplace?: 'shopify' | 'amazon' | 'googleShopping';
  data: Omit<Product, 'id' | 'timestamps'>; // Store everything except id and timestamps
  createdBy?: string;
  notes?: string;
}

export interface VersionMetadata {
  id: string;
  versionNumber: number;
  timestamp: Date | Timestamp;
  type: 'import' | 'optimization' | 'manual';
  marketplace?: 'shopify' | 'amazon' | 'googleShopping';
  createdBy?: string;
  notes?: string;
  // Include data only for Version 1 (Initial Import)
  data?: Omit<Product, 'id' | 'timestamps'>;
}

// Helper function to format version type for display
export function formatVersionType(type: string, marketplace?: string): string {
  switch (type) {
    case 'import':
      return 'Initial Import';
    case 'optimization':
      return `${marketplace ? marketplace.charAt(0).toUpperCase() + marketplace.slice(1) : ''} Optimization`;
    case 'manual':
      return 'Manual Update';
    default:
      return type;
  }
}

// Helper function to get version label
export function getVersionLabel(version: ProductVersion): string {
  const date = (version.timestamp instanceof Date ?
    version.timestamp :
    version.timestamp.toDate()
  ).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
  
  return `v${version.versionNumber} - ${formatVersionType(version.type, version.marketplace)} (${date})`;
}